import {
  type BaseQueryState,
  dehydrateQueryStateBase,
  dehydrateQueryStateToStringBase,
  hydrateQueryStateBase,
  hydrateQueryStateFromStringBase,
} from "@store/utils/queryStateUtils";
import type { Location } from "history";

import { DEFAULT_PAGE_LIMIT } from "@helpers/constants";

import {
  defaultSortField,
  getDefaultSortOrder,
} from "../../modules/app/access-requests/data/fields";
import type { LocalAccessRequest } from "../../modules/app/access-requests/data/types";

export type AccessRequestsQueryState = BaseQueryState<LocalAccessRequest>;

const QUERY_DEFAULTS = {
  defaultSort: {
    fieldName: defaultSortField.fieldName,
    direction: getDefaultSortOrder(defaultSortField),
  },
  defaultLimit: DEFAULT_PAGE_LIMIT,
} as const;

export function hydrateAccessRequestsQueryState(
  location: Location,
): AccessRequestsQueryState {
  return hydrateQueryStateBase<LocalAccessRequest>(location, QUERY_DEFAULTS);
}

export function dehydrateAccessRequestsQueryState(opts: {
  queryState: AccessRequestsQueryState;
  location: Location;
}): URLSearchParams {
  return dehydrateQueryStateBase<LocalAccessRequest>(opts);
}

export function hydrateAccessRequestsQueryStateFromString(
  searchString: string,
): AccessRequestsQueryState {
  return hydrateQueryStateFromStringBase<LocalAccessRequest>(
    searchString,
    QUERY_DEFAULTS,
  );
}

export function dehydrateAccessRequestsQueryStateToString(
  queryState: AccessRequestsQueryState,
): string {
  return dehydrateQueryStateToStringBase<LocalAccessRequest>(queryState);
}
